<template>
    <app-base-main parentTable>
      <template #filter-group>
        <app-filter-group
            ref="filtergroup"
            @query="$gjNoticeQuery"
            @reset="$gjReset">
          <gj-radio-group
              v-model="filter.type"
              :options="[
                {id: null, text: '全部'},
                ...ProductEnum.typeOption
              ]"
              @input="radioInput">
          </gj-radio-group>
          <gj-select-input
              v-model="filter.keyword1"
              :options="[
                {id: 0, text: 'SKU'},
                {id: 1, text: '产品名称'},
              ]"
              :width="['100px', '100px']"
          ></gj-select-input>
          <gj-select
              v-model="filter.state"
              :options="ProductEnum.statusOption"
              placeholder="产品状态"
          ></gj-select>
          <gj-select-input
            v-if="clientWidth > 1450"
            v-model="filter.keyword2"
            :options="[
              {id: 0, text: '采购员'},
              {id: 1, text: '产品开发'},
            ]"
            :width="['100px', '100px']"
          ></gj-select-input>
          <gj-category-select
              v-model="filter.categoryId"
              multiple
          ></gj-category-select>
          <gj-brand-select
              v-if="clientWidth > 1450"
              v-model="filter.brandId"
              active>
          </gj-brand-select>
          <gj-creator-select
              v-model="filter.createUserId"
          ></gj-creator-select>
          <gj-date-picker
              v-if="clientWidth > 1450"
              v-model="filter.createDate"
              type="daterange"
              tooltip="创建时间"
          ></gj-date-picker>
          <template v-if="clientWidth <= 1450" #advancedFilter>
            <gj-select-input
                v-model="filter.keyword2"
                :options="[
                {id: 0, text: '采购员'},
                {id: 1, text: '产品开发'},
              ]"
                :width="['100px', '100px']"
            ></gj-select-input>
            <gj-brand-select
                v-model="filter.brandId"
                active>
            </gj-brand-select>
            <gj-date-picker
              v-model="filter.createDate"
              type="daterange"
              tooltip="创建时间"
          ></gj-date-picker>
          </template>
          <template #right>
            <view-setting
                :ref="REF_VIEW_SETTING"
                save-mode="remote"
                :use-default="true"
                :module-name="moduleName"
                :config="model"
                :fn-generate-params="generateViewParams"
                @view-change="handleChangeView"
                @view-complete="handCompleteView"
            >
            </view-setting>
          </template>
        </app-filter-group>
      </template>
      <template #operate-group>
        <gj-button
            v-if="$permission('product:add')"
            type="primary"
            @click="addProduct(ProductEnum.type.PRODUCT), userGuideNextStep()">
          添加产品
        </gj-button>
        <gj-button
            v-if="$permission('product:add')"
            @click="addProduct(ProductEnum.type.ASSEMBLY)">
          添加组合产品
        </gj-button>
        <gj-dropdown-button v-if="$permission('product:import')">
          导入
          <template #dropdown>
            <gj-dropdown-item @click="importNormalProduct">普通产品</gj-dropdown-item>
            <gj-dropdown-item @click="importAssemblyProduct">组合产品</gj-dropdown-item>
            <gj-dropdown-item @click="importUpdateProduct">更新产品</gj-dropdown-item>
          </template>
        </gj-dropdown-button>
        <template v-if="$permission('product:edit')">
          <gj-button
              :disabled="!selectedAllIs('state', ProductEnum.status.INACTIVE)"
              @click="activeProduct(selectedRows)">
            启用
          </gj-button>
          <gj-button
              :disabled="!selectedAllIs('state', ProductEnum.status.ACTIVE)"
              @click="inactiveProduct(selectedRows)">
            停用
          </gj-button>
        </template>
        <gj-button
            v-if="$permission('product:delete')"
            :disabled="noSelect"
            @click="deleteProduct(selectedRows)">
          删除
        </gj-button>
        <gj-dropdown-button :disabled="noSelect" v-if="$permission('product:printLabels')">
          批量打印
          <template #dropdown>
            <gj-dropdown-item :disabled="noSelect" @click="printLabel(selectedRows)">产品标签打印(模板)</gj-dropdown-item>
            <gj-dropdown-item :disabled="noSelect" @click="customPrintLabel(selectedRows)">产品标签打印(自定义)</gj-dropdown-item>
          </template>
        </gj-dropdown-button>
        <gj-button
            :disabled="noSelect"
            @click="syncPicture(selectedRows)">
          同步商品图片
        </gj-button>
      </template>
      <template #tool-group>
        <gj-tool-group
            log @viewLog="viewLog"
            :sort-gjtable="$refs.gjTable"
            :download="$permission('product:export')" download-url="/supply/product/export" :download-params="globalParams"
            help
            setting :table-name="tableName" :table-columns="columns"
        ></gj-tool-group>
      </template>
      <template #table>
        <gj-table
          ref="gjTable"
          adaptParent
          :show-overflow="false"
          :name="tableName"
          :loading="loading"
          :data="tableData"
          :columns="columns"
          size="has-picture"
          sortable="custom"
          selection
          :index-tree-node="true"
          :selectable="selectable"
          :tree-config="{ transform: true, lazy: true, hasChild: 'hasChild', loadMethod: loadChildrenMethod, indent: 0  }"
          :pagination="pagination"
          :default-sort="{prop: 'createTime', order: 'descending'}"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery">
          <template v-slot:name="{row}">
            <gj-tooltip
                :text-line="2"
                :content="row.name">
              {{row.name | defaultShow}}
            </gj-tooltip>
          </template>

          <template v-slot:state="{row}">
            <gj-tag type="text" style="margin-right: 10px" shape="rectangle"
                    :color="row.state | optionColor(ProductEnum.statusOption)">
              {{ row.state | optionText(ProductEnum.statusOption) }}
            </gj-tag>
          </template>

          <template v-slot:assembly="{row}">
            <template v-if="row.isTreeChild">
              数量：{{row.num | defaultShow}}
            </template>
            <gj-tooltip v-else :content="row.assembly" :textLine="2">{{row.assembly}}</gj-tooltip>
          </template>

          <template v-slot:op="{ row }">
            <gj-button-group v-if="!row.isTreeChild" type="dropdown-op">
              <gj-button type="text" @click="viewProduct(row)">详情</gj-button>
              <gj-button v-if="$permission('product:edit')" type="text" @click="editProduct(row)">编辑</gj-button>
              <template #dropdown v-if="$permission('product:edit') || $permission('product:delete')
              || $permission('product:add') || $permission('product:printLabels')">
                <template v-if="$permission('product:edit')">
                  <gj-dropdown-item
                      v-if="row.state === ProductEnum.status.INACTIVE"
                      @click="activeProduct([row])">
                    启用
                  </gj-dropdown-item>
                  <gj-dropdown-item
                      v-if="row.state === ProductEnum.status.ACTIVE"
                      @click="inactiveProduct([row])">
                    停用
                  </gj-dropdown-item>
                </template>
                <gj-dropdown-item v-if="$permission('product:delete')" @click="deleteProduct([row])">删除</gj-dropdown-item>
                <gj-dropdown-item v-if="$permission('product:add')" @click="copyProduct(row)">复制产品</gj-dropdown-item>
                <gj-dropdown-item v-if="$permission('product:printLabels')" @click="printLabel([row])">打印标签</gj-dropdown-item>
              </template>
            </gj-button-group>
          </template>
        </gj-table>
      </template>
      <template v-if="userGuideState" #base-content>
        <new-user-guide ref="newUserGuide" @closeModal="closeModal"></new-user-guide>
      </template>
    </app-base-main>
</template>

<script>
  import AppProductAddModal from "./modal/add/product-add-modal"
  import AppImportUpdateProductModal from "./modal/import-update-product-modal"
  import AppImportProductModal from "./modal/import-product-modal"
  import AppImportAssemblyProductModal from "./modal/import-assembly-product-modal"
  import PrintProductLabelModal from "./modal/print-label/print-product-label-modal"
  import AppLabelPrintModal from '@/views/components/label-print-modal/label-print-modal';
  import {OpEnum, ProductEnum} from "../../../../utils/options";
  import {defaultVal, isMeaningful, isMeaningless} from "../../../../utils/common";
  import {queryMixin, responseMixin, selectionMixin, userGuideMixin} from "../../../../minxins";
  import {convertToDate, generateViewParams} from "../../../../utils/date.util";
  import {deleteProduct, disableOrEnableProduct, getProductPage, syncProductImage} from "../../../../api/product";
  import model from "./viewConfig";
  import NewUserGuide from "./components/new-user-guide"

  export default {
    name: "app-product-manager",
    mixins: [queryMixin, selectionMixin, responseMixin, userGuideMixin],
    components: { NewUserGuide },
    watch: {
      userGuideState: {
        immediate: true,
        handler(newState,oldState) {
          if(newState && !oldState) {
            this.$nextTick(() => {
              this.$refs.filtergroup.refreshAdvanced(false)
            })
          }
        },
    }
  },
    data() {
      return {
        tableName: 'product',
        tableData: [],
        showAdvancedFilterProp:true,
        columns: [
          {id: 'smallImageUrl', header: '图片', field: 'picture:smallImageUrl', width: '80px', fixed: "left", align: 'center', default: true, disabled: true},
          {id: 'sku', header: 'SKU', field: 'sku', minWidth: '140px', fixed: "left", default: true, overflowLine: 2, disabled: true, sortable: true, copyable: true},
          {id: 'name', header: '产品名称', field: 'slot:name', minWidth: '220px', default: true},
          {id: 'categoryName', header: '品类', field: 'categoryName', overflowLine: 2, minWidth: '150px', default: true},
          {id: 'brandName', header: '品牌', field: 'brandName', overflowLine: 2, minWidth: '150px', default: true},
          {id: 'productType', header: '产品类型', field: 'option:productType', width: '100px', options: ProductEnum.typeOption, default: true},
          {id: 'state', header: '产品状态', field: 'slot:state', width: '80px', options: ProductEnum.statusOption, default: true},
          {id: 'expectDeliveryDays', header: '预计交期(天)', field: 'expectDeliveryDays', width: '100px', align: 'right', default: true},
          {id: 'createUserName', header: '创建人', field: 'createUserName', width: '120px', default: true},
          {id: 'createTime', header: '创建时间', field: 'createTime', width: '155px', default: true},
          {id: 'assembly', header: '组合规则', field: 'slot:assembly', width: '150px', overflowLine: 2, default: false},
          {id: 'updateTime', header: '更新时间', field: 'updateTime', width: '155px', default: false},
          {id: 'buyer', header: '采购员', field: 'buyer', width: '120px', default: false},
          {id: 'productDeveloper', header: '产品开发', field: 'productDeveloper', width: '120px', default: false},
          {id: 'op', header: '操作', field: 'slot:op', width: '120px', fixed: 'right', notCustomColumn: true}
        ],
        filter: {
          type: null,
          state: ProductEnum.status.ACTIVE,
          categoryId: [],
          brandId: null,
          createUserId: null,
          createDate: null,
          keyword1: {
            key: 0,
            value: null
          },
          keyword2: {
            key: 0,
            value: null
          }
        },
        sortTable:null,
        ProductEnum: ProductEnum,
        moduleName: 'PRODUCT',
        model,
        cacheOptions: {
          useCache: true,
        }
      }
    },
    created() {
      this.sort.prop = 'createTime';
    },
    methods: {
      //异步获取父asin展开数据
      //异步获取父asin展开数据
      loadChildrenMethod({ row }) {
        // 异步加载子节点
        return new Promise(resolve => {
          setTimeout(() => {
            const childs = row.productAssemblyList || []
            childs.forEach(item => item.isTreeChild = true)
            resolve(childs)
          }, 50)
        })
      },
      selectable(row) {
        return !row.isTreeChild;
      },
      radioInput() {
        this.$gjNoticeQuery()
      },
      generateViewParams,
      /**
       * 设置全局查询参数
       */
      mergeRemoteParams(params) {
        const createDate = params.createDate ? params.createDate : params.startDateTime && params.endDateTime ? [params.startDateTime, params.endDateTime] : this.filter.createDate
        this.filter = Object.assign({}, this.filter, {
          ...params,
          createDate
        })
      },
      loadViewComplete() {
        this.$emit('query');
      },
      /**
       *
       * @param params 查询条件参数
       * @override queryMixin
       * @returns {{type: *}}
       */
      $gjCacheCallback(params) {
        return {
          type: params.type
        };
      },
      $gjQueryInitParams() {
        return {
          filter: {
            type: null,
            state: ProductEnum.status.ACTIVE,
            categoryId: [],
            brandId: null,
            createUserId: null,
            createDate: null,
            keyword1: {
              key: 0,
              value: null
            },
            keyword2: {
              key: 0,
              value: null
            }
          }
        };
      },
      $gjQuery() {
        // 构造查询参数
        const params = {
          model: {
            productType: defaultVal(this.filter.type, null),
            sku: (this.filter.keyword1.key === 0 && this.filter.keyword1.value)  ? this.filter.keyword1.value  : null,
            name: this.filter.keyword1.key === 1 ? this.filter.keyword1.value : null,
            state: defaultVal(this.filter.state, null),
            brandIds: isMeaningful(this.filter.brandId) ? [this.filter.brandId] : null,
            categoryIds: isMeaningful(this.filter.categoryId) ? this.filter.categoryId : null,
            buyer: this.filter.keyword2.key === 0 ? this.filter.keyword2.value : null,
            productDeveloper: this.filter.keyword2.key === 1 ? this.filter.keyword2.value : null,
            createUserId: defaultVal(this.filter.createUserId, null),
            startCreateTime: this.filter.createDate ? convertToDate(this.filter.createDate[0]) : null,
            endCreateTime: this.filter.createDate ? convertToDate(this.filter.createDate[1]) : null,
          },
          ...this.queryPagination,

          ...this.querySort
        };
        this.globalParams = params;
        // 查询
        this.loading = true;
        getProductPage(params)
          .then((data) => {
            if (isMeaningful(data)) {
              data.records.forEach((item, index) => {
                if(isMeaningless(item.productAssemblyList)) {
                  item.productAssemblyList = []
                }
                item.productAssemblyList.forEach(items => {
                  items.isTreeChild = true;
                })
                item.hasChild = item.productAssemblyList.length > 0
              });
              this.tableData = data.records;
              this.pagination = this.getPagination(data);
            } else {
              this.tableData = [];
            }
          })
          .complete(() => {
            this.loading = false;
          });
      },
      viewProduct(row) {
        this.$gjCreate(AppProductAddModal, {
          props: {
            product: row,
            sku: row.sku,
            productType: row.productType,
            opType: OpEnum.type.VIEW,
          },
          on: {
            updated: () => {
              this.$gjResetPage();
            }
          }
        });
      },
      editProduct(row) {
        this.$gjCreate(AppProductAddModal, {
          props: {
            product: row,
            sku: row.sku,
            productType: row.productType,
            opType: OpEnum.type.UPDATE,
          },
          on: {
            updated: () => {
              this.$gjResetPage();
            }
          }
        });
      },
      addProduct(productType) {
       this.adAuthModal = this.$gjCreate(AppProductAddModal, {
          props: {
            productType,
          },
          on: {
            created: () => {
              this.$gjResetPage();
            },
            userGuide: () => {
              // 引导用户
              this.isAutoAdAuthModal = true
              this.userGuideNextStep()

            },
            close: () => {
              // 关闭引导用户
              if(!this.isAutoAdAuthModal) {
                this.userGuideCancel()
                this.isAutoAdAuthModal = false
              }
            },
          }
        });
      },
      closeModal() {
        if(this.adAuthModal)  {
          this.isAutoAdAuthModal = true; // 是否为主动销毁
          this.adAuthModal.$gjDestroy();
          this.adAuthModal = null;
        }
    
     },
      copyProduct(row) {
        this.$gjCreate(AppProductAddModal, {
          props: {
            product: row,
            sku: row.sku,
            productType: row.productType,
            opType: OpEnum.type.COPY,
          },
          on: {
            created: () => {
              this.$gjResetPage();
            }
          }
        });
      },
      activeProduct(rows) {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: '启用确认',
            content: rows.length === 1 ? `确定要启用 SKU：${rows[0].sku} 吗？` : `已选中 ${rows.length} 个产品，确定要批量启用吗？`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              disableOrEnableProduct({
                ids: rows.map(e => e.id),
                state: ProductEnum.status.ACTIVE
              })
                .then((res) => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    this.$gjResetPage();
                    modal.$gjDestroy();
                  });
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      deleteProduct(rows) {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: '删除确认',
            content: rows.length === 1
              ? `确定要删除 SKU：${rows[0].sku} 吗？一旦删除不可恢复，请谨慎操作！`
              : `已选中 ${rows.length} 个产品，确定要批量删除吗？一旦删除不可恢复，请谨慎操作！`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              deleteProduct({
                ids: rows.map(e => e.id)
              })
                .then((res) => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    this.$gjResetPage();
                    modal.$gjDestroy();
                  });
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      inactiveProduct(rows) {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: '停用确认',
            content: rows.length === 1 ? `确定要停用 SKU：${rows[0].sku} 吗？` : `已选中 ${rows.length} 个产品，确定要批量停用吗？`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              disableOrEnableProduct({
                ids: rows.map(e => e.id),
                state: ProductEnum.status.INACTIVE
              })
                .then((res) => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    this.$gjResetPage();
                    modal.$gjDestroy();
                  });
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      importNormalProduct() {
        this.$gjCreate(AppImportProductModal, {
          on: {
            importFileSuccess: () => {
              this.$gjResetPage();
            }
          }
        });
      },
      importAssemblyProduct() {
        this.$gjCreate(AppImportAssemblyProductModal, {
          on: {
            importFileSuccess: () => {
              this.$gjResetPage();
            }
          }
        });
      },
      importUpdateProduct() {
        this.$gjCreate(AppImportUpdateProductModal, {
          on: {
            importFileSuccess: () => {
              this.$gjResetPage();
            }
          }
        });
      },
      printLabel(rows) {
        this.$gjCreate(PrintProductLabelModal, {
          props: {
            products: rows
          }
        });
      },

      customPrintLabel(rows) {
        if (rows.length > 50) {
          this.$gjMessage.error('一次最多操作50条数据');
          return;
        }
        this.$gjCreate(AppLabelPrintModal, {
          props: {
            modelTitle: '打印产品标签',
            source: 'sku',
            items: rows,
            tabType: 'PRODUCT',
            columns: [
              {id: 'picture', header: '图片', field: 'picture:smallImageUrl', minWidth: '60px'},
              {id: 'sku', header: 'SKU', field: 'sku', minWidth: '80px'},
              {id: 'name', header: '产品标题', field: 'slot:name', minWidth: '120px'},
              {id: 'namePrint', header: '打印产品标题', field: 'slot:namePrint', minWidth: '120px'},
              {id: 'categoryName', header: '品类', field: 'categoryName', overflowLine: 1, minWidth: '100px'},
              {id: 'brandName', header: '品牌', field: 'brandName', overflowLine: 1, minWidth: '100px'},
              {id: 'printCount', header: 'slot:printCount', field: 'slot:printCount', align: 'left', width: '140px'},
              {id: 'op', header: '操作', field: 'slot:op', width: '80px', fixed: 'right', notCustomColumn: true, }
            ]
          }
        });
      },

      syncPicture(rows) {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: '同步商品确认',
            content: `同步商品图片后将删除您本地已上传的图片，是否确定？`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              syncProductImage(rows.map(e => e.sku))
                .then((res) => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success(res.data);
                    this.$gjResetPage();
                    modal.$gjDestroy();
                  });
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      viewLog() {
        this.$gjCreate('gj-log-modal', {
          props: {
            url: '/supply/product/logPage',
            opTypeOption: ProductEnum.logTypeOption,
            params: {
              model: {}
            }
          }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
/deep/ .lazy-tree-child-row {
    background-color: #f7f8fa;
  }
/deep/ .fixed-left--wrapper .lazy-tree-child-row {
  td:nth-child(1) {
    border-left: 3px solid #1F6EEF;
  }
}
</style>
